import React from 'react';

import Icon from 'dpl/common/components/Icon';
import MiniOverlayModal from 'dpl/common/mini_overlay_modal/components/MiniOverlayModal';
import FixedTooltipPortal from 'dpl/common/tooltip/components/FixedTooltipPortal';
import SmartLink from 'dpl/components/SmartLink';
import { LEARNING_CENTER_PAYMENT_PROTECTION_PATH } from 'dpl/shared/constants/urls';
import { isMobileUA } from 'dpl/shared/utils';

const IS_MOBILE = isMobileUA();

function Content() {
  return (
    <div className="pt2 ph1">
      <div className="flex flex-column gap-16 md:gap-24 font-16 md:font-18 lh-body secondary">
        <div>
          <div className="inline-flex items-center justify-center bg-gray-200 br3 pv3 ph3 mb3 mb8-md">
            <Icon
              className="primary"
              name="gooddog-shield"
              height="32px"
              width="32px"
            />
          </div>
          <h4 className="font-28 md:font-32 lh-title default-color">
            You’re protected on Good Dog
          </h4>
        </div>
        <p>
          When you pay and communicate on Good Dog, you’re covered by Payment
          Protection. If anything doesn’t go as planned, we’re here to help.
        </p>
        <div>
          <h5 className="font-sans font-16 md:font-18 default-color">
            What’s covered
          </h5>
          <p>
            Your deposit and final puppy payment are both protected when you pay
            through Good Dog. If you run into an issue — your breeder is
            unresponsive, misrepresents their puppy, or doesn’t follow through
            on what was agreed — reach out to our team and we’ll work to make it
            right.
          </p>
        </div>
        <div>
          <h5 className="font-sans font-16 md:font-18 default-color">
            How it works
          </h5>
          <p>
            If something comes up, start by working with your breeder directly.
            If you need more support, contact us as soon as possible and we’ll
            guide you through next steps.
          </p>
        </div>
        <SmartLink
          className="fw-medium primary"
          to={LEARNING_CENTER_PAYMENT_PROTECTION_PATH}
          target="_blank"
        >
          Learn more about how you’re protected
        </SmartLink>
      </div>
    </div>
  );
}

interface PaymentProtectionModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function PaymentProtectionModal({
  isOpen,
  onClose
}: PaymentProtectionModalProps) {
  if (IS_MOBILE) {
    return (
      <FixedTooltipPortal isVisible={isOpen} onCloseClick={onClose}>
        <Content />
      </FixedTooltipPortal>
    );
  }

  if (isOpen) {
    return (
      <MiniOverlayModal
        maxWidth="840px"
        onCloseClick={onClose}
        closeButtonClassName="ba b--light-gray br-100 padding-h-6 padding-v-6 mt4 mr4"
        contentClassName="bg-white pv14 ph16"
      >
        <Content />
      </MiniOverlayModal>
    );
  }

  return null;
}
